import React, { Component } from "react";
// import MainProfile from './MainProfile.jsx';
import InitialMainProfile from "./InitialMainProfile.jsx";
import { withStyles } from "@material-ui/core/styles";
import { compose } from "redux";
import { Button, Radio, TextField, Typography } from "@material-ui/core";
import IconButton from "@material-ui/core/IconButton";
import CloseIcon from "@material-ui/icons/Close";
import LogoutAlert from "../../components/Alert/LogoutAlert.jsx";
import UpdateProfile from "./UpdateProfile.jsx";
import * as actions from '../../actions/index.js';
import { FormattedMessage, injectIntl } from "react-intl";
import { ROLE_CUSTOMER, ROLE_PROVIDER } from "../../utils/config/constants.js";
import { withRouter } from "react-router-dom";
import { AccountBalanceWallet, SearchIcon } from "@material-ui/icons";
import { connect } from "react-redux";
import { Clear, Add, Remove, ArrowLeft, ArrowRight, ArrowForward, ArrowBack, Category,  } from '@material-ui/icons';
import ContentLoader from "react-content-loader";
import { Box, FormControl, FormControlLabel, FormLabel, RadioGroup } from "@mui/material";
import Dropzone from "react-dropzone";
import uploadIcon from '../../assets/img/profile-upload-icon.png'
import { NotificationManager } from "react-notifications";
import NavbarNew from "../../components/NavBarNew/NavbarNew.js";

let isMounted = false;

const AdditionImagePicker = ({ title, handleDropRejected, handleDrop, userData, imageUploaded, front_imageId, noOfUpload = 1, onlyAdd = false }) => {
    return (
        <React.Fragment>
            {(() => {
                const arr = [];
                for (let i = 0; i < noOfUpload; i++) {
                    arr.push(
                      <div style={{ 
                            // position: "absolute", 
                            // top: "207px", 
                            // left: "210px" 
                        }}>
                            <Dropzone
                                onDrop={handleDrop}
                                accept="image/jpeg,image/jpg,image/png"
                                multiple={true}
                                maxSize={10485760}
                                onDropRejected={handleDropRejected}
                            >
                                {({ getRootProps, getInputProps }) => (
                                    <div {...getRootProps()}>
                                        <input {...getInputProps()} />
                                        {/* <img src={uploadIcon} style={{ height: "25px" }} /> */}
                                        <Box > <Add fontSize='large' /></Box>
                                    </div>
                                )}
                            </Dropzone>
                        </div>
                    );
                }
                return arr;
            })()}
        </React.Fragment>
    );
}
class AdditionalInfoScreenNew extends Component {
    constructor(props) {
        super(props);

        this.state = {
            home_aval: 1,
            home_instruction: '',
            home_stay: '',
            img_url_1:'',
            img_url_2:'',
            img_url_3:'',
            img_url_4:'',
            taskDetailsPrev: this.props.history.location.state.taskBooking,
            bookingInfoDataPrev : this.props.history.location.state.bookingInfoData,
            profileImagebase64Data1: null,
            profileImagebase64Data2: null,
            profileImagebase64Data3: null,
            profileImagebase64Data4: null,
        };
        this.handleImage1Drop = this.handleImage1Drop.bind(this)
        this.handleImage2Drop = this.handleImage2Drop.bind(this)
        this.handleImage3Drop = this.handleImage3Drop.bind(this)
        this.handleImage4Drop = this.handleImage4Drop.bind(this)

    }
    componentDidMount() {
        console.log("ADDITONAL INFO taskDetailsPrev DETSSSSSSSS---", this.state.taskDetailsPrev);
        console.log("this.state.bookingInfoDataPrev---", this.state.bookingInfoDataPrev);
    }

    componentWillUnmount() {
    }

    renderLoading = index => {
        return (
            <div style={{ width: 250, margin: 10, height: 250 }} key={index}>
                <ContentLoader
                    height={200}
                    width={200}
                    speed={2}
                    borderRadius={5}
                    primaryColor="#f3f3f3"
                    secondaryColor="#ecebeb"
                >
                    <rect x="0" y="0" rx="0" ry="0" width="200" height="160" />
                    <rect
                        x="100"
                        y="100"
                        rx="0"
                        ry="0"
                        width="200"
                        height="10"
                    />
                </ContentLoader>
            </div>
        );
    };

    handleChange = (event) => {
        console.log("e.target.value", event);
        // this.setState({
        //     home_aval: e.target.value
        // })
      };

      handleRadioChange = event => {
        this.setState({ home_aval: event.target.value});

        //    this.setState({color: '#0078ff'});
        console.log("yoyo",event.target.value)
    };

    onContinuePressed = () => {
        let aditionalData = {
            home_stay:this.state.home_aval,
            home_instruction: this.state.home_stay,
            instructions: this.state.home_instruction,
            booking_img_1:  this.state.img_url_1  ,
            booking_img_2:  this.state.img_url_2 ,
            booking_img_3:  this.state.img_url_3  ,
            booking_img_4:  this.state.img_url_4
        }

        this.props.history.push('/user/confirm_booking',{
            bookingDetails: this.state.taskDetailsPrev, 
            bookingInfoData: this.state.bookingInfoDataPrev,
            aditionalData : aditionalData
        })
    }

    _handleReaderLoaded1 = e => {
        console.log("file uploaded 2: ", e);
        let binaryString = e.target.result;
        this.setState({
            profileImagebase64Data1: btoa(binaryString)
        });
    };
    _handleReaderLoaded2 = e => {
        console.log("file uploaded 2: ", e);
        let binaryString = e.target.result;
        this.setState({
            profileImagebase64Data2: btoa(binaryString)
        });
    };
    _handleReaderLoaded3 = e => {
        console.log("file uploaded 2: ", e);
        let binaryString = e.target.result;
        this.setState({
            profileImagebase64Data3: btoa(binaryString)
        });
    };
    _handleReaderLoaded4 = e => {
        console.log("file uploaded 2: ", e);
        let binaryString = e.target.result;
        this.setState({
            profileImagebase64Data4: btoa(binaryString)
        });
    };

    handleImage1Drop(files) {
        console.warn("CHOOSING FILE SHR",files)
        const file = files[0]
        if (file) {
            const reader = new FileReader();
            reader.onload = this._handleReaderLoaded1.bind(this);
            reader.readAsBinaryString(file);
        }
        var fData = new FormData()
        fData.append('attribute', "booking_img1");
        fData.append('image', files[0])
        this.props.additionImageUpload(
            fData,
            this.onAdditionalImgDone
        )
    }

    handleImage2Drop(files) {
        console.warn("CHOOSING FILE SHR",files)
        const file = files[0]
        if (file) {
            const reader = new FileReader();
            reader.onload = this._handleReaderLoaded2.bind(this);
            reader.readAsBinaryString(file);
        }
        var fData = new FormData()
        fData.append('attribute', "booking_img2");
        fData.append('image', files[0])
        this.props.additionImageUpload(
            fData,
            this.onAdditionalImgDone2
        )
    }

    handleImage3Drop(files) {
        console.warn("CHOOSING FILE SHR",files)
        const file = files[0]
        if (file) {
            const reader = new FileReader();
            reader.onload = this._handleReaderLoaded3.bind(this);
            reader.readAsBinaryString(file);
        }
        var fData = new FormData()
        fData.append('attribute', "booking_img3");
        fData.append('image', files[0])
        this.props.additionImageUpload(
            fData,
            this.onAdditionalImgDone3
        )
    }

    handleImage4Drop(files) {
        console.warn("CHOOSING FILE SHR",files)
        const file = files[0]
        if (file) {
            const reader = new FileReader();
            reader.onload = this._handleReaderLoaded4.bind(this);
            reader.readAsBinaryString(file);
        }
        var fData = new FormData()
        fData.append('attribute', "booking_img4");
        fData.append('image', files[0])
        this.props.additionImageUpload(
            fData,
            this.onAdditionalImgDone4
        )
    }

    onAdditionalImgDone = (success, data) => {
        console.log("onAdditionalImgDone SUCCESS", success)
        console.log("onAdditionalImgDone DATA", data)
        if (success) {
            console.log(data.data, 'image upload')
            this.setState({
                img_url_1: data.data.url,
                imageUploaded: true
            }, () => {
                NotificationManager.success("Success", data.message)

            })
        } else {
            this.setState({
                imageUploaded: false
            })
            NotificationManager.error("Oops!", data)
        }
    }

    onAdditionalImgDone2 = (success, data) => {
        console.log("onAdditionalImgDone SUCCESS", success)
        console.log("onAdditionalImgDone DATA", data)
        if (success) {
            console.log(data.data, 'image upload')
            this.setState({
                img_url_2: data.data.url,
                imageUploaded: true
            }, () => {
                NotificationManager.success("Success", data.message)

            })
        } else {
            this.setState({
                imageUploaded: false
            })
            NotificationManager.error("Oops!", data)
        }
    }

    onAdditionalImgDone3 = (success, data) => {
        console.log("onAdditionalImgDone SUCCESS", success)
        console.log("onAdditionalImgDone DATA", data)
        if (success) {
            console.log(data.data, 'image upload')
            this.setState({
                img_url_3: data.data.url,
                imageUploaded: true
            }, () => {
                NotificationManager.success("Success", data.message)

            })
        } else {
            this.setState({
                imageUploaded: false
            })
            NotificationManager.error("Oops!", data)
        }
    }

    onAdditionalImgDone4 = (success, data) => {
        console.log("onAdditionalImgDone SUCCESS", success)
        console.log("onAdditionalImgDone DATA", data)
        if (success) {
            console.log(data.data, 'image upload')
            this.setState({
                img_url_4: data.data.url,
                imageUploaded: true
            }, () => {
                NotificationManager.success("Success", data.message)

            })
        } else {
            this.setState({
                imageUploaded: false
            })
            NotificationManager.error("Oops!", data)
        }
    }


    handleImage1DropRejected = (...args) => console.log('reject', args);


    render() {


        var well={
            boxShadow: "2px 1px 5px #ddd",
            backgroundColor: '#fff',
            padding: 10,
            marginBottom: 20,
            display: 'flex',
            flexDirection: 'row',
            justifyContent: 'space-between',
            alignItems: 'center',
            // textAlign: 'center',
            cursor: 'pointer',
            borderRadius: 5
        }
        return (
            <div className="tz-2-com tz-2-main h4-padding">
                <div style={{ paddingBottom: "25px" }} className="db-list-com">
                    <div className="row">
                        <div className="col-md-12">
                            <NavbarNew
                                title='Additional Info' 
                                goback={() => this.props.history.goBack(null)} 
                            />
                            <div>
                                <div>
                                    <p style={{fontSize: 25,}}>Will you be Home?</p>
                                    <div style={{
                                    display: 'flex',
                                    flexDirection: 'row',
                                    alignItems: 'center',
                                    // justifyContent: 'center',
                                }}>
                                        <Radio
                                            className="checked-radio"
                                            checked={
                                                this.state.home_aval==1
                                            }
                                            onChange={event => this.handleRadioChange(event)}
                                            // onChange={this.handlePaymentOption}
                                            value="1"
                                            color="primary"
                                            //  style={{ backgroundColor: this.state.color }}
                                        /><p style={{textAlign: 'center', marginTop: 10}}>Yes</p>
                                        <Radio
                                            className="checked-radio"
                                            checked={
                                                this.state.home_aval==2
                                            }
                                            onChange={event => this.handleRadioChange(event)}
                                            // onChange={this.handlePaymentOption}
                                            value="2"
                                            color="primary"
                                            //  style={{ backgroundColor: this.state.color }}
                                        /><p  style={{textAlign: 'center', marginTop: 10}}>No</p>
                                    </div>
                                    {
                                        this.state.home_aval == 2 &&
                                        <textarea
                                            // id="required"
                                            // className="border-0 form-control chat-textarea"
                                            // onKeyUp={this._handleKeyPress.bind(this)}
                                            onChange={(e) => this.setState({
                                                home_stay: e.target.value
                                            })}
                                            value={this.state.home_stay}
                                            placeholder="Please leave a message if you will not be home."
                                            style={{
                                                height: '11vh',
                                                borderRadius: '10px',
                                                marginBottom: 20
                                            }}
                                        />
                                    }
                                </div>
                                <div>
                                    <p style={{fontSize: 25,}}>Add Notes / Instructions</p>
                                    <textarea
                                        // id="required"
                                        // className="border-0 form-control chat-textarea"
                                        // onKeyUp={this._handleKeyPress.bind(this)}
                                        onChange={(e) => this.setState({
                                            home_instruction: e.target.value
                                        })}
                                        value={this.state.home_instruction}
                                        placeholder="Add instructions"
                                        style={{
                                            height: '20vh',
                                            borderRadius: '10px',
                                            marginBottom: 20
                                        }}
                                    />
                                </div>
                                <div>
                                    <p style={{fontSize: 25,}}>Add Photos</p>
                                    <p style={{color: 'red'}}>*Allowed file size is 10MB and supports only JPEG/PNG</p>
                                    <div style={{
                                        display: 'flex',
                                        justifyContent: 'space-around',
                                        alignItems: 'center',
                                        border: '1px solid #eee',
                                        borderRadius: '10px',
                                    }}>
                                        {
                                            this.state.img_url_1 
                                            ? 
                                             <img 
                                            //  src={this.state.img_url_1} 
                                            src={this.state.profileImagebase64Data1 ? 
                                                `data:image;base64,${this.state.profileImagebase64Data1}` :this.state.img_url_1}
                                             style={{ height: '8rem', width: '8rem', borderRadius: 10 }} /> 
                                            //  console.log("this.state.img_url_1",this.state.img_url_1)
                                            : <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', p: 5, color: '#717175' }}>
                                            {/* <Box > <Add fontSize='large' /></Box> */}
                                            <AdditionImagePicker
                                                handleDrop={this.handleImage1Drop}
                                                handleDropRejected={this.handleImage1DropRejected}
                                                userData={this.props.userData}
                                                state={this.state}
                                                imageUploaded={this.state.imageUploaded}
                                                // front_imageId={this.state.front_imageId}
                                                noOfUpload={1}
                                            />
                                            <Typography style={{ color: '#717175' }}>
                                                Add Photo 1
                                            </Typography>
                                        </Box>
                                        }
                                        {
                                            this.state.img_url_2 
                                            ? 
                                             <img 
                                            //  src={this.state.img_url_1} 
                                            src={this.state.profileImagebase64Data2 ? 
                                                `data:image;base64,${this.state.profileImagebase64Data2}` :this.state.img_url_2}
                                             style={{ height: '8rem', width: '8rem', borderRadius: 10 }} /> 
                                            //  console.log("this.state.img_url_1",this.state.img_url_1)
                                            : <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', p: 5, color: '#717175' }}>
                                            {/* <Box > <Add fontSize='large' /></Box> */}
                                            <AdditionImagePicker
                                                handleDrop={this.handleImage2Drop}
                                                handleDropRejected={this.handleImage1DropRejected}
                                                userData={this.props.userData}
                                                state={this.state}
                                                imageUploaded={this.state.imageUploaded}
                                                // front_imageId={this.state.front_imageId}
                                                noOfUpload={1}
                                            />
                                            <Typography style={{ color: '#717175' }}>
                                                Add Photo 2
                                            </Typography>
                                        </Box>
                                        }
                                        {
                                            this.state.img_url_3
                                            ? 
                                             <img 
                                            //  src={this.state.img_url_1} 
                                            src={this.state.profileImagebase64Data3 ? 
                                                `data:image;base64,${this.state.profileImagebase64Data3}` :this.state.img_url_3}
                                             style={{ height: '8rem', width: '8rem', borderRadius: 10 }} /> 
                                            //  console.log("this.state.img_url_1",this.state.img_url_1)
                                            : <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', p: 5, color: '#717175' }}>
                                            {/* <Box > <Add fontSize='large' /></Box> */}
                                            <AdditionImagePicker
                                                handleDrop={this.handleImage3Drop}
                                                handleDropRejected={this.handleImage1DropRejected}
                                                userData={this.props.userData}
                                                state={this.state}
                                                imageUploaded={this.state.imageUploaded}
                                                // front_imageId={this.state.front_imageId}
                                                noOfUpload={1}
                                            />
                                            <Typography style={{ color: '#717175' }}>
                                                Add Photo 3
                                            </Typography>
                                        </Box>
                                        }
                                        {
                                            this.state.img_url_4
                                            ? 
                                             <img 
                                            //  src={this.state.img_url_1} 
                                            src={this.state.profileImagebase64Data4 ? 
                                                `data:image;base64,${this.state.profileImagebase64Data4}` :this.state.img_url_4}
                                             style={{ height: '8rem', width: '8rem', borderRadius: 10 }} /> 
                                            //  console.log("this.state.img_url_1",this.state.img_url_1)
                                            : <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', p: 5, color: '#717175' }}>
                                            {/* <Box > <Add fontSize='large' /></Box> */}
                                            <AdditionImagePicker
                                                handleDrop={this.handleImage4Drop}
                                                handleDropRejected={this.handleImage1DropRejected}
                                                userData={this.props.userData}
                                                state={this.state}
                                                imageUploaded={this.state.imageUploaded}
                                                // front_imageId={this.state.front_imageId}
                                                noOfUpload={1}
                                            />
                                            <Typography style={{ color: '#717175' }}>
                                                Add Photo 4
                                            </Typography>
                                        </Box>
                                        }
                                    </div>
                                </div>
                            </div>
                            
                            <div style={{
                                    display: 'flex',
                                    justifyContent: 'flex-end',
                                    marginTop: 70,
                                    marginRight: 20
                                }}>
                                    <p 
                                    onClick={this.onContinuePressed}
                                    style={{
                                        backgroundColor: '#0078ff',
                                        padding: '7px 20px',
                                        color: '#fff',
                                        borderRadius: 5,
                                        fontSize: 17,
                                        fontWeight: 'bold',
                                        textAlign: 'center'
                                    }}>CONTINUE</p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

const mapStateToProps = ({ settings, categories, providers, auth }) => {
    return {
        settings,
        categoryData: categories.categoryData,
        featuredProviderList: providers.featuredProviderList,
        featuredProviderLoader: providers.featuredProviderLoader,
        userData: auth.userData,

    };
};
const composedProfile = compose(connect(mapStateToProps, actions));
export default composedProfile(withRouter(AdditionalInfoScreenNew));



// WEBPACK FOOTER //
// ./src/views/User/AdditionalInfoScreenNew.jsx